import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "~/components//ui/toast"
import { useToast } from "~/components//ui/use-toast"

export function Toaster() {
  const { toasts } = useToast()

  const chatToasts = toasts.filter(toast => toast.variant === 'chat')
  const regularToasts = toasts.filter(toast => toast.variant !== 'chat')

  return (
    <ToastProvider>
      {/* Regular toasts in viewport */}
      {regularToasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
      
      {/* Chat toasts with custom positioning */}
      {chatToasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose className="text-white hover:text-white/80" />
          </Toast>
        )
      })}
    </ToastProvider>
  )
}
